import { $win, $header, $hero, $wrapper, getCurrentDevice } from './utils';

const scrolledHeader = () => {
	const scrollOffset = 100;

	$win.on('load scroll', function() {
		if ( $hero.length !== 0 && getCurrentDevice() == 'desktop' ) {
			$wrapper.toggleClass('scrolled', $win.scrollTop() > scrollOffset);
		}
	})
}

const solidHeader = () => {
	if ( $hero.length === 0 || getCurrentDevice() != 'desktop' ) {
		console.log(getCurrentDevice())
		$wrapper.addClass('no-hero scrolled');
	};
}

const navDropdown = () => {
	$('.nav ul ul').closest('li').addClass('has-dropdown');
}

export default function headerUI() {
	scrolledHeader();

	navDropdown();

	solidHeader();
}
